import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Supabase auth storage adapter that uses Capacitor Preferences on native
 * (Android/iOS) and localStorage on web.
 *
 * Capacitor Preferences writes to Android SharedPreferences / iOS NSUserDefaults,
 * which survive APK/IPA updates. localStorage is tied to the WebView data
 * partition and can be cleared on update — causing unwanted logouts.
 */
export function createAuthStorage() {
  if (!Capacitor.isNativePlatform()) {
    return localStorage;
  }

  return {
    getItem: async (key: string): Promise<string | null> => {
      const { value } = await Preferences.get({ key });
      return value;
    },
    setItem: async (key: string, value: string): Promise<void> => {
      await Preferences.set({ key, value });
    },
    removeItem: async (key: string): Promise<void> => {
      await Preferences.remove({ key });
    },
  };
}
